import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { FavoriteWalletStar } from '@root/entities/wallet/ui/favorite-wallet-star/favorite-wallet-star'
import { WalletNameCell } from '@root/entities/wallet/ui/table/column/wallet-name-cell'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
}

export const WalletsTableWalletCell: React.FC<Props> = ({ wallet }) => {
  const [color] = useAtom(wallet.color)
  const [name] = useAtom(wallet.name)
  return (
    <Root
      beforeName={<Indicator style={{ backgroundColor: color }} />}
      name={name}
      afterName={<FavoriteWalletStar wallet={wallet} />}
    />
  )
}

const Root = styled(WalletNameCell)`
  padding-inline: 12px;
`
const Indicator = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 3px;
`
